/**
 * Enum representing the types of individuals.
 * @readonly
 * @enum {int}
 */
exports.TIPO_ESTACIONAMENTO = {
  ESTACIONAMENTO_PRIVADO: 1,
  ESTACIONAMENTO_NA_RUA: 2,
};
